export const environment = {
  production: false,
  // apiUrl: 'https://api.payment-app.info',
  blMaverickApiUrl: ' https://testgateway.immaverick.com',
  nagadApiUrl: 'https://nagadpay.techapi24.com',
  // baseCloud7CmsApiUrl: 'https://localhost:7198',
  //payment monitoring API.
  baseCloud7CmsApiUrl: 'https://reportapi.immaverick.com',


  // nagadApiUrl: 'https://localhost:7241',
  apiUrl: 'https://blworker.immaverick.com',
  menuConfig:
  {
    dashboard: [
      {
        label: 'Robi',
        path: '/robi'
      },
      {
        label: 'Robi DOB',
        path: '/charging/robi'
      },
      {
        label: 'Banglalink',
        path: '/banglalink'
      },
      {
        label: 'Grameenphone',
        path: '/grameenphone/all'
      }
    ],
    configuration: [
      {
        label: "Grameenphone",
        path: "/config/grameenphone"
      },
      {
        label: "Robi",
        path: "/config/robi"
      },
      {
        label: "Banglalink",
        path: "/config/banglalink"
      },
      {
        label: "Nagad",
        path: "/config/nagad"
      }
    ],
    notifyVendor: [
      {
        "label": "Banglalink",
        "path": "/sync-vendor/banglalink-sync-vendor"
      },
      {
        "label": "Grameenphone",
        "path": "/sync-vendor/grameenphone-sync-vendor"
      },
      {
        "label": "Robi/Bkash(Cloud7)",
        "path": "/sync-vendor/robi-bkash-sync-vendor"
      }
    ],
    notifyAdsVendor: [
      {
        "label": "Banglalink",
        "path": "/ads-notify-vendor/banglalink"
      },
      {
        "label": "Robi",
        "path": "/ads-notify-vendor/robi"
      },
      {
        "label": "Grameenphone",
        "path": "/ads-notify-vendor/grameenphone"
      },
      {
        "label": "BKash",
        "path": "/ads-notify-vendor/bkash"
      }
    ],
    chargingNofity: [
      {
        "label": "Banglalink",
        "path": "/charging-notify/banglalink"
      },
      {
        "label": "Robi",
        "path": "/charging-notify/robi"
      },
      {
        "label": "Grameenphone",
        "path": "/charging-notify/grameenphone"
      }
    ],
    others: [
      {
        "label": "Banglalink",
        "path": "/others/banglalink"
      }
    ],
    reporting: [
      {
        "label": "Dashboard",
        "path": "/reporting/dashboard",
        "roles" : ['Admin', 'Cloud7','Reporter']
      },
      {
        "label": "Operators",
        "path": "/reporting/operators",
        "roles" : ['Admin', 'Cloud7','Reporter']
      },
      {
        "label": "Traffic",
        "path": "/reporting/traffic",
        "roles" : ['Admin', 'Cloud7','Reporter']
      },
      {
        "label": "Ads",
        "path": "/reporting/ads",
        "roles" : ['Admin','Cloud7']
      }
    ]
  },

};
